const novakBooks = {
  slug: "novak-books",
  title: "Novak Books",
  category: "Print Media",
  client: "Hinton Publishing",
  duration: "4 Months",
  cover: "/assets/9zh6YwzW0lOAZBWPNljZRfhKo.png",
  summary: "Typesetting all seven volumes of the Serbian edition of the Novak Djokovic book series.",
  gallery: [
    "/assets/TXAK14AXR5tFChq1CTe7k5QBqk.png",
    "/assets/9zh6YwzW0lOAZBWPNljZRfhKo.png",
    "/assets/LaKQhkQSTy3ch7ZKyVH4Y9OZRA.jpg",
    "/assets/OeZ56ri3VN6WSdSrT6i3MUpWUdw.png",
  ],
  blocks: [
    {
      type: "richText",
      html: `<h2><strong>Novak Tennis Book Series: Serbian Edition Typesetting</strong></h2>
<p><br></p>`,
    },
    {
      type: "link",
      href: "https://shop.novakdjokovicfoundation.org/product-category/novak-djokovic-fan-collection/?v=5435c69ed3bc",
      label: "Novak Bookstore",
    },
    {
      type: "richText",
      html: `<h4><strong>Overview</strong></h4>
<p>For the original Novak Djokovic tennis book series, my main responsibility was typesetting all seven volumes of the Serbian edition. The project called for a focus on clarity, consistency, and visual appeal across a substantial body of work, ensuring each book was easy to read and true to the brand’s spirit.</p>
<h4><strong>My Approach</strong></h4>
<p>I managed the entire typesetting process, carefully organizing chapter structures, headings, and text flows to maintain a cohesive look from start to finish. Special attention was paid to typography, spacing, and layout, balancing readability with a sense of elegance that matched the significance of Novak’s story.</p>
<h4><strong>Vision and Execution</strong></h4>
<p>The goal was to create an inviting reading experience for Serbian tennis fans and collectors, respecting both the content’s cultural importance and the expectations of a high-quality sports publication. My work ensured that every page felt accessible and visually balanced, from the opening dedication to the closing statistics.</p>
<h4><strong>Challenges and Solutions</strong></h4>
<p>With seven books to handle, maintaining consistency was a key challenge. I developed and applied a unified typesetting style guide, streamlining the process while making it easy to adapt layouts for each unique volume.</p>
<h4><br></h4>
<h4><br></h4>
<p>The final Serbian series delivers a polished, professional collection that captures Novak’s legacy, making these books a valued addition to any tennis fan’s library.</p>`,
    },
  ],
  relatedSlugs: ["trendless", "animatic-remastered", "seven-due-dates"],
  seo: {
    title: "Novak Books — Matia Dosen",
    description: "UX Designer and Creative",
  },
}

export default novakBooks
